'use strict';/* global define */define('modules/feedback/services/feedback-process-sharing-grants/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
controller.$inject = ["$scope", "FeedbackProcessSharingGrants"];
function controller($scope,FeedbackProcessSharingGrants){// jshint validthis:true
// jshint latedef:false
$scope.FeedbackProcessSharingGrants=FeedbackProcessSharingGrants;// ---
}module.exports=controller;});
